import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const StoringYourResume = () => {
  return (
    <>
      <Subtitle>Storing Your Resume</Subtitle>
      <Paragraph>
        You may elect to store resumes in your Glints account, and use those
        resumes when applying for a job.
      </Paragraph>
      <Paragraph>
        In order to provide Advertisers with the most relevant information about
        you, social network information (including but not limited to GitHub or
        LinkedIn profiles) that you provide may also be scanned by Glints and
        relevant content may be displayed to Advertisers. If you do not want
        content from social networks to be displayed to Advertisers, do not
        provide social network information.. For more information on how your
        resume will be used, see above under the heading “Glints Profile”.
      </Paragraph>
    </>
  );
};
